module.exports = __webpack_public_path__ + "static/img/ewm-sj2.cf78358.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/ewm-sj2.jpg
// module id = yE1C
// module chunks = 1